import React, { useEffect, useState } from "react";
import { EditModal } from "../EditModal";
import { AvatarUploader } from "@appComponents/AvatarUploader/AvatarUploader";
import BttfAxios from "@features/utils/axios";

type ProfilePictureModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  onUploadFile?: ({
    imageId,
    imageUrl,
  }: {
    imageId: number | string;
    imageUrl: string;
  }) => void;
};

export const ProfilePictureModal = ({
  isOpen,
  onClose,
  onUploadFile,
}: ProfilePictureModalProps) => {
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<string | null>(null);
  const [uploaderResetTrigger, setUploaderResetTrigger] = useState(null);

  const handleFileSelect = (fileBase64: string) => {
    setErrorMsg(null);
    setSelectedFile(fileBase64);
  };

  const handleError = (msg: string) => {
    setErrorMsg(msg);
  };

  const uploadFile = (
    newImageUrl: string | undefined,
    type = "profile_avatar"
  ) => {
    const data = {
      image: {
        type,
        file: newImageUrl,
      },
    };

    BttfAxios.post(
      "/api/images",
      data,
      (resp) => {
        const imageId = resp.data.id;
        const imageUrl = resp.data.file_url;

        onUploadFile({ imageId, imageUrl });
      },
      (err) => {
        setErrorMsg("Upload failed. Please try again.");
      }
    );
  };

  const handleSave = () => {
    if (selectedFile) {
      uploadFile(selectedFile);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setSelectedFile(null);
      setUploaderResetTrigger(Date.now());
    }
  }, [isOpen]);

  return (
    <EditModal
      open={isOpen}
      onClose={onClose}
      onSave={handleSave}
      title="Profile picture"
    >
      <>
        <AvatarUploader
          onSelect={handleFileSelect}
          onError={handleError}
          resetTrigger={uploaderResetTrigger}
        />
        {errorMsg && (
          <p className="mt-2 text-sm text-red-500 text-center">{errorMsg}</p>
        )}
      </>
    </EditModal>
  );
};
